import React from 'react';
import { TooltippedText } from '../../../components/tooltipped-text';

/** Django-admin escape hatch; only rendered for users with the Django `is_staff` flag. */
export const ProviderAdminLink: React.FC<{ providerId: string }> = ({ providerId }) => (
  <TooltippedText tooltipContent="Open in Django admin">
    <a
      href={`/admin/providers/provider/${providerId}/change/`}
      target="_blank"
      rel="noreferrer"
      className="tw:text-zinc-500 tw:hover:text-brand-green-0"
      aria-label="Open in Django admin"
      data-testid={`provider-admin-link-${providerId}`}
      // The link sits inside clickable list rows; opening the admin must not
      // also open the drawer.
      onClick={(event) => event.stopPropagation()}
    >
      <i className="fal fa-user-gear" />
    </a>
  </TooltippedText>
);
